const ReportsSkeleton = () => {
  return (
    <div className="animate-pulse px-5 py-12">
      <div className="h-20 w-full bg-n200 rounded-lg mb-6"></div>
      <div className="h-20 w-full bg-n200 rounded-lg mb-3"></div>
      <div className="h-20 w-full bg-n200 rounded-lg"></div>
    </div>
  );
};

export default ReportsSkeleton;
